import { useState, useEffect } from 'react'

export function useViewerCount(initial: number): number {
  const [count, setCount] = useState(initial)

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => prev + Math.floor(Math.random() * 3) + 1)
    }, 4500)

    return () => clearInterval(interval)
  }, [])

  return count
}
